import MealPlanIntroductionConfig from './MealPlanIntroductionConfig';

export default MealPlanIntroductionConfig;
